module.exports = __webpack_public_path__ + "static/media/fazhan2.a3827a81.png";